export default __webpack_public_path__ + "static/media/activeCollectionIcon.eb8b4256.svg";